import fetch from '../../../../utils/fetch'
import {PROJECT_ROLE_MANAGER, PROJECT_ROLE_MEMBER} from "../../../../constants/project_users_roles";
import avatarModule from "./avatar";
import statsModule from "./stats";

const getInitialState = () => {
  return {
    isLoadingSession: false,
    sessionData: JSON.parse(window.localStorage.getItem('sessionData')),
    sessionError: null,

    isLoadingUpdate: false,

    notificationPage: 1,
    notificationItems: 10,
    notificationTotal: 0,
    notificationSortBy: "createdAt",
    notificationSortDirection: "desc",
    notificationSortDesc: true,

    projectPage: 1,
    projectItems: 10,
    projectTotal: 0,
    projectSearch: null,
    projectSortBy: "approvedAt",
    projectSortDirection: "desc",
    projectSortDesc: true,
  }
}

const state = getInitialState();

const actions = {

  fetchSession({commit, dispatch, rootState}) {
    commit(types.SESSION_LOADING)
    return fetch('/users/' + rootState.user.auth.userId)
      .then(response => response.json())
      .then((data) => {
        commit(types.SESSION, data);
        // dispatch('user/profile/stats/get', {}, {root: true});
        dispatch('user/profile/avatar/get', {}, {root: true});
        return true
      })
      .catch((e) => {
        commit(types.SESSION_ERROR, e.message);
        return false
      })
  },

  fetchSessionNoAvatar({commit, rootState}) {
    commit(types.SESSION_LOADING)
    return fetch('/users/' + rootState.user.auth.userId)
      .then(response => response.json())
      .then((data) => {
        commit(types.SESSION, data);
        return true
      })
      .catch((e) => {
        commit(types.SESSION_ERROR, e.message);
        return false
      })
  },

  updateUserProfile({commit, state, dispatch, rootState}, data) {
    commit(types.UPDATE_LOADING)
    return fetch('/users/' + rootState.user.auth.userId, {method: 'PUT', body: JSON.stringify(data)})
      .then(response => response.json())
      .then((data) => {
        commit(types.UPDATE_LOADING)
        commit(types.SESSION, data);
        return data
      })
      .catch((e) => {
        commit(types.SESSION_ERROR, e.message);
        return false
      })
  },

  updateUserPassword({commit, state, dispatch, rootState}, data) {
    commit(types.UPDATE_LOADING)
    return fetch('/users/' + rootState.user.auth.userId + '/password', {method: 'PATCH', body: JSON.stringify(data)})
      .then(response => response.json())
      .then((data) => {
        commit(types.UPDATE_LOADING)
        return data
      })
      .catch((e) => {
        commit(types.SESSION_ERROR, e.message);
        return false
      })
  },

  setNotificationTablePage({commit}, page) {
    commit(types.SET_NOTIFICATION_PAGE, page)
  },
  setNotificationTableItems({commit}, items) {
    commit(types.SET_NOTIFICATION_ITEMS, items)
  },
  setNotificationTableTotal({commit}, total) {
    commit(types.SET_NOTIFICATION_TOTAL, total)
  },
  setNotificationTableSortBy({commit}, sortBy) {
    commit(types.SET_NOTIFICATION_SORT_BY, sortBy)
  },
  setNotificationTableSortDirection({commit}, sortDirection) {
    commit(types.SET_NOTIFICATION_SORT_DIRECTION, sortDirection)
  },
  setNotificationTableSortDesc({commit}, sortDesc) {
    commit(types.SET_NOTIFICATION_SORT_DESC, sortDesc)
  },

  setProjectTablePage({commit}, page) {
    commit(types.SET_PROJECT_PAGE, page)
  },
  setProjectTableItems({commit}, items) {
    commit(types.SET_PROJECT_ITEMS, items)
  },
  setProjectTableTotal({commit}, total) {
    commit(types.SET_PROJECT_TOTAL, total)
  },
  setProjectTableSearch({commit}, search) {
    commit(types.SET_PROJECT_SEARCH, search)
  },
  setProjectTableSortBy({commit}, sortBy) {
    commit(types.SET_PROJECT_SORT_BY, sortBy)
  },
  setProjectTableSortDirection({commit}, sortDirection) {
    commit(types.SET_PROJECT_SORT_DIRECTION, sortDirection)
  },
  setProjectTableSortDesc({commit}, sortDesc) {
    commit(types.SET_PROJECT_SORT_DESC, sortDesc)
  },

  reset({commit}) {
    commit(types.RESET)
    localStorage.removeItem('sessionData')
  },
}

const getters = {
  hasSession(state) {
    return !!state.sessionData
  },
  id(state) {
    return state.sessionData ? state.sessionData.id : null
  },
  iri(state) {
    return state.sessionData ? state.sessionData['@id'] : null
  },
  isVerified(state) {
    return state.sessionData ? state.sessionData.isVerified : false
  },
  userName(state) {
    return state.sessionData ? state.sessionData.username : ""
  },
  displayName(state) {
    return state.sessionData ? state.sessionData.displayName : ""
  },
  email(state) {
    return state.sessionData ? state.sessionData.email : ""
  },
  changeEmailPending(state) {
    return state.sessionData ? state.sessionData.changeEmailPending : false
  },
  firstName(state) {
    return state.sessionData ? state.sessionData.firstName : ""
  },
  lastName(state) {
    return state.sessionData ? state.sessionData.lastName : ""
  },
  memberSince(state) {
    return state.sessionData ? state.sessionData.createdAt : ""
  },

  receivesNewsletter(state) {
    return state.sessionData ? state.sessionData.receivesNewsletter : null
  },

  privacySetting(state) {
    return state.sessionData ? state.sessionData.privacySetting : null
  },

  scistarter(state) {
    return state.sessionData ? state.sessionData.scistarterId : null
  },

  isAdmin(state) {
    return state.sessionData ? state.sessionData.isAdmin === true : false
  },

  membershipArray(state) {
    if (!state.sessionData || !state.sessionData.memberships) {
      return []
    }
    return [...state.sessionData.memberships].sort(compareByProjectName);
  },
  membershipMap(state) {
    if (!state.sessionData || !state.sessionData.memberships || state.sessionData.memberships.length === 0) {
      return {}
    }
    return state.sessionData.memberships.reduce((accumulator, membership) => {
      if (!membership.projectId) {
        return accumulator
      }
      accumulator[membership.projectId] = {
        ...membership,
        isManager: (
          membership.approved === true &&
          membership.role === PROJECT_ROLE_MANAGER
        ),
        isMember: (
          membership.approved === true && (
            membership.role === PROJECT_ROLE_MANAGER ||
            membership.role === PROJECT_ROLE_MEMBER
          )
        ),
        isPending: (
          membership.approved === false
        )
      }
      return accumulator
    }, {})// The empty object here is the initial value of the accumulated value

  },

  organizationMembershipMap(state) {
    if (!state.sessionData || !state.sessionData.organizationMemberships || state.sessionData.organizationMemberships.length === 0) {
      return {}
    }
    return state.sessionData.organizationMemberships.reduce((accumulator, membership) => {
      if (!membership.organizationUrl) {
        return accumulator
      }
      accumulator[membership.organizationUrl] = {
        ...membership,
        isManager: (
          membership.approved === true &&
          membership.role === PROJECT_ROLE_MANAGER
        ),
        isPending: (
          membership.approved === false
        )
      }
      return accumulator
    }, {})// The empty object here is the initial value of the accumulated value

  },

  sessionData(state) {
    return state.sessionData
  },

  isLoading(state) {
    return state.isLoading
  },

  isLoadingUpdate(state) {
    return state.isLoadingUpdate
  },

  isLoadingSession(state) {
    return state.isLoadingSession
  },

  picture(state) {
    if (state.sessionData && state.sessionData.picture) {
      return state.sessionData.picture
    }
    return null
  },

  picturePath(state) {
    if (state.sessionData
      && state.sessionData.picture
      && state.sessionData.picture.path
    ) {
      return state.sessionData.picture.path
    }
    return "/assets/images/default_avatar.png"
  },

  notificationPage(state) {
    return state && state.notificationPage
  },
  notificationItems(state) {
    return state && state.notificationItems
  },
  notificationTotal(state) {
    return state && state.notificationTotal
  },
  notificationSortBy(state) {
    return state && state.notificationSortBy
  },
  notificationSortDirection(state) {
    return state && state.notificationSortDirection
  },
  notificationSortDesc(state) {
    return state && state.notificationSortDesc
  },

  projectPage(state) {
    return state && state.projectPage
  },
  projectItems(state) {
    return state && state.projectItems
  },
  projectTotal(state) {
    return state && state.projectTotal
  },
  projectSearch(state) {
    return state && state.projectSearch
  },
  projectSortBy(state) {
    return state && state.projectSortBy
  },
  projectSortDirection(state) {
    return state && state.projectSortDirection
  },
  projectSortDesc(state) {
    return state && state.projectSortDesc
  },
}

const compareByProjectName = (a, b) => {
  let nameA = a.projectName.toUpperCase(); // ignore upper and lowercase
  let nameB = b.projectName.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  // names must be equal
  return 0;
}

const types = {
  SESSION_LOADING: 'SESSION_LOADING',
  SESSION: 'SESSION',
  SESSION_ERROR: 'SESSION_ERROR',
  UPDATE_USER_AVATAR: 'UPDATE_USER_AVATAR',
  RESET: 'RESET',

  UPDATE_LOADING: 'UPDATE_LOADING',

  SET_AUTH_VIOLATIONS: 'SET_AUTH_VIOLATIONS',
  SET_AUTH_PASSWORD_RESET: 'SET_AUTH_PASSWORD_RESET',
  RESET_AUTH_ERROR: 'RESET_AUTH_ERROR',
  SET_REFRESH_TIMEOUT: 'SET_REFRESH_TIMEOUT',

  SET_NOTIFICATION_PAGE: 'SET_NOTIFICATION_PAGE',
  SET_NOTIFICATION_ITEMS: 'SET_NOTIFICATION_ITEMS',
  SET_NOTIFICATION_TOTAL: 'SET_NOTIFICATION_TOTAL',
  SET_NOTIFICATION_SORT_BY: 'SET_NOTIFICATION_SORT_BY',
  SET_NOTIFICATION_SORT_DIRECTION: 'SET_NOTIFICATION_SORT_DIRECTION',
  SET_NOTIFICATION_SORT_DESC: 'SET_NOTIFICATION_SORT_DESC',

  SET_PROJECT_PAGE: 'SET_PROJECT_PAGE',
  SET_PROJECT_ITEMS: 'SET_PROJECT_ITEMS',
  SET_PROJECT_TOTAL: 'SET_PROJECT_TOTAL',
  SET_PROJECT_SEARCH: 'SET_PROJECT_SEARCH',
  SET_PROJECT_SORT_BY: 'SET_PROJECT_SORT_BY',
  SET_PROJECT_SORT_DIRECTION: 'SET_PROJECT_SORT_DIRECTION',
  SET_PROJECT_SORT_DESC: 'SET_PROJECT_SORT_DESC',
}

const mutations = {
  [types.SESSION_LOADING](state) {
    state.isLoadingSession = true;
  },
  [types.UPDATE_LOADING](state) {
    state.isLoadingUpdate = !state.isLoadingUpdate;
  },
  [types.SESSION](state, sessionData) {
    state.sessionData = sessionData
    localStorage.setItem('sessionData', JSON.stringify(state.sessionData))
    state.isLoadingSession = false
  },
  [types.SESSION_ERROR](state, error) {
    state.sessionError = error
    state.isLoadingSession = false
  },
  // Update user avatar without refetching session
  [types.UPDATE_USER_AVATAR](state, imageData) {
    if (state.sessionData) {
      state.sessionData = {
        ...state.sessionData,
        picture: imageData
      }
      localStorage.setItem('sessionData', JSON.stringify(state.sessionData))
    }
  },

  [types.SET_NOTIFICATION_PAGE](state, page) {
    state.notificationPage = page;
  },
  [types.SET_NOTIFICATION_ITEMS](state, items) {
    state.notificationItems = items;
  },
  [types.SET_NOTIFICATION_TOTAL](state, total) {
    state.notificationTotal = total;
  },
  [types.SET_NOTIFICATION_SORT_BY](state, sortBy) {
    state.notificationSortBy = sortBy;
  },
  [types.SET_NOTIFICATION_SORT_DIRECTION](state, sortDirection) {
    state.notificationSortDirection = sortDirection;
  },
  [types.SET_NOTIFICATION_SORT_DESC](state, sortDesc) {
    state.notificationSortDesc = sortDesc;
  },

  [types.SET_PROJECT_PAGE](state, page) {
    state.projectPage = page;
  },
  [types.SET_PROJECT_ITEMS](state, items) {
    state.projectItems = items;
  },
  [types.SET_PROJECT_TOTAL](state, total) {
    state.projectTotal = total;
  },
  [types.SET_PROJECT_SEARCH](state, search) {
    state.projectSearch = search;
  },
  [types.SET_PROJECT_SORT_BY](state, sortBy) {
    state.projectSortBy = sortBy;
  },
  [types.SET_PROJECT_SORT_DIRECTION](state, sortDirection) {
    state.projectSortDirection = sortDirection;
  },
  [types.SET_PROJECT_SORT_DESC](state, sortDesc) {
    state.projectSortDesc = sortDesc;
  },

  [types.RESET](state) {
    window.localStorage.removeItem('sessionData');
    Object.assign(state, {...getInitialState(), sessionData: null,})
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  modules: {
    avatar: avatarModule,
    stats: statsModule,
  }
}

